<div class="modal-header">
  <h5 class="modal-title">Override DOS Range</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="row mb-3">
    <label for="dosMin" class="col-sm-4 col-form-label">Min DOS</label>
    <div class="col-sm-8">
      <input type="number" id="dosMin" class="form-control" [(ngModel)]="dosMin" min="1" />
    </div>
  </div>
  <div class="row">
    <label for="dosMax" class="col-sm-4 col-form-label">Max DOS</label>
    <div class="col-sm-8">
      <input type="number" id="dosMax" class="form-control" [(ngModel)]="dosMax" min="1" />
    </div>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger mt-3">
    {{ errorMessage }}
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="close()">Cancel</button>
  <button class="btn btn-primary" (click)="save()">Save</button>
</div>